import { grayColor } from "assets/jss/material-dashboard-pro-react.js";

// const toolbarBg = `linear-gradient(to bottom, ${grayColor[4]}, ${grayColor[4]})`;
const toolbarBg = grayColor[4] + "88";
const iconColor = grayColor[6];
const dividerColor = "rgba(0,0,0,0.12)";
const toolbarGap = 4;

export const floatingToolbarStyles = (theme) => ({
  container: {
    position: "fixed",
    top: 0,
    right: 24,
    gap: toolbarGap,
    zIndex: 1100,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  mobileContainer: {
    position: "fixed",
    top: 0,
    right: 60,
    zIndex: 1100,
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
    },
  },

  mobileTrigger: {
    position: "relative",
    background: toolbarBg,
    color: iconColor,
    border: "none",
    padding: "4px 8px 5px",
    borderRadius: "0 0 6px 6px",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
    transition: "padding 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      paddingBottom: "8px",
    },
  },

  mobileTriggerIcon: {
    fontSize: "20px",
  },

  mobileDropdown: {
    marginTop: 0,
    borderRadius: "0 0 6px 6px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
  },

  mobileBadgeDot: {
    position: "absolute",
    top: 3,
    right: 3,
    width: 7,
    height: 7,
    borderRadius: "50%",
    backgroundColor: "#f44336",
  },
});

export const floatingToolbarItemStyles = () => ({
  item: {
    background: toolbarBg,
    color: iconColor,
    border: "none",
    margin: 0,
    padding: "4px 8px 5px",
    minWidth: 34,
    minHeight: 28,
    position: "relative",
    boxSizing: "border-box",
    cursor: "pointer",
    // boxShadow: "0 0 4px rgba(0,0,0,0.2) inset",
    transition: "padding 0.2s ease, border-radius 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "0 0 6px 6px",
    gap: "3px",
    "&:hover": {
      paddingTop: "8px",
      borderRadius: "0 0 6px 6px",
    },
  },

  itemFirst: {
    // borderRadius: "0 0 0 6px",
    // borderRight: `1px solid ${dividerColor}`,
  },

  itemLast: {
    // borderRadius: "0 0 6px 0",
  },

  itemOnly: {
    // borderRadius: "0 0 6px 6px",
  },

  // Todos os itens compartilham o mesmo tratamento visual: cantos
  // inferiores arredondados, sem bordas laterais. A separacao entre
  // botoes vem do ``gap`` do container (4px). Antes, ``itemMiddle``
  // forcava cantos retos + borda direita — resquicio de quando os
  // botoes eram visualmente contiguos (sem gap). Removido para
  // manter paridade entre primeiro/meio/ultimo.
  itemMiddle: {},

  icon: {
    fontSize: "18px",
    display: "flex",
  },

  label: {
    fontSize: "11px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    lineHeight: 1,
  },

  desktopBadge: {
    position: "absolute",
    top: 2,
    right: -3,
    zIndex: 1,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "11px",
    minWidth: "14px",
    padding: "0 2px",
    borderRadius: "10px",
    boxSizing: "border-box",
    backgroundColor: "#f44336",
    color: "#fff",
    fontSize: "9px",
    fontWeight: 500,
    lineHeight: 1,
    pointerEvents: "none",
  },

  desktopBadgeDot: {
    position: "absolute",
    top: 3,
    right: 3,
    zIndex: 1,
    width: 7,
    height: 7,
    borderRadius: "50%",
    backgroundColor: "#f44336",
    boxShadow: "0 0 0 1px #fff",
    pointerEvents: "none",
  },

  mobileBadge: {
    "& .MuiBadge-badge": {
      fontSize: "9px",
      height: "13px",
      minWidth: "13px",
      padding: "0 2px",
    },
  },

  mobileItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 16px",
    fontSize: "14px",
    color: grayColor[7],
    cursor: "pointer",
    "&:hover": {
      backgroundColor: grayColor[8],
    },
    "& + &": {
      borderTop: `1px solid ${dividerColor}`,
    },
  },

  mobileIcon: {
    fontSize: "18px",
    color: iconColor,
    display: "flex",
  },

  mobileLabel: {
    flex: 1,
  },
});
